var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEspacoKids(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "espaco_kids",
    "data-name": "espaco kids",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 102.394 101.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1203",
    "data-name": "Caminho 1203",
    d: "M74.332,22.563a1.92,1.92,0,0,0-3.652,0L68.631,28.87H62a1.92,1.92,0,0,0-1.128,3.473l5.366,3.9-2.049,6.308A1.92,1.92,0,0,0,67.141,44.7l5.366-3.9,5.366,3.9a1.92,1.92,0,0,0,2.954-2.146l-2.049-6.308,5.366-3.9a1.92,1.92,0,0,0-1.128-3.473H76.382ZM70.922,30.1l1.584-4.877L74.091,30.1a1.92,1.92,0,0,0,1.826,1.327h5.128L76.9,34.444a1.92,1.92,0,0,0-.7,2.146l1.584,4.877-4.148-3.014a1.92,1.92,0,0,0-2.257,0L67.23,41.467l1.585-4.877a1.92,1.92,0,0,0-.7-2.146L63.968,31.43H69.1A1.92,1.92,0,0,0,70.922,30.1Z",
    transform: "translate(-21.629 -7.646)",
    fill: "#cb8f55",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1204",
    "data-name": "Caminho 1204",
    d: "M105.1,116.719a.64.64,0,0,0,.554.96h16.626a.64.64,0,0,0,.554-.96l-8.313-14.4a.64.64,0,0,0-1.108,0Zm8.867-10.239-4.988,8.639h9.976Z",
    transform: "translate(-37.807 -34.936)",
    fill: "#cb8f55",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1205",
    "data-name": "Caminho 1205",
    d: "M45.279,113.64A8.639,8.639,0,1,1,36.639,105,8.639,8.639,0,0,1,45.279,113.64Zm-2.56,0a6.08,6.08,0,1,1-6.08-6.08A6.079,6.079,0,0,1,42.719,113.64Z",
    transform: "translate(-10.081 -37.937)",
    fill: "#cb8f55",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1206",
    "data-name": "Caminho 1206",
    d: "M24.319,5.12A5.12,5.12,0,0,1,29.438,0H72.316a5.12,5.12,0,0,1,5.12,5.12V47.357a5.106,5.106,0,0,1-.372,1.92H97.274a5.12,5.12,0,0,1,5.12,5.12V96.634a5.12,5.12,0,0,1-5.12,5.12H54.4a5.1,5.1,0,0,1-3.2-1.123,5.1,5.1,0,0,1-3.2,1.123H5.12A5.12,5.12,0,0,1,0,96.634V54.4a5.12,5.12,0,0,1,5.12-5.12H24.691a5.105,5.105,0,0,1-.372-1.92Zm5.12-1.28H72.316A1.28,1.28,0,0,1,73.6,5.12V47.357a1.28,1.28,0,0,1-1.28,1.28H29.438a1.28,1.28,0,0,1-1.28-1.28V5.12A1.28,1.28,0,0,1,29.438,3.84ZM54.4,97.914a1.28,1.28,0,0,1-1.28-1.28V54.4a1.28,1.28,0,0,1,1.28-1.28H97.274a1.28,1.28,0,0,1,1.28,1.28V96.634a1.28,1.28,0,0,1-1.28,1.28ZM48,53.117a1.28,1.28,0,0,1,1.28,1.28V96.634A1.28,1.28,0,0,1,48,97.914H5.12a1.28,1.28,0,0,1-1.28-1.28V54.4a1.28,1.28,0,0,1,1.28-1.28Z",
    fill: "#cb8f55",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspacoKids);
export default __webpack_public_path__ + "static/media/espaco-kids.36951cb2dae5c64c5440f25bba73fc42.svg";
export { ForwardRef as ReactComponent };